module.exports = __webpack_public_path__ + "img/Austin Griffith.0de38f6a.jpg";